import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa"

import { Icon } from "../../common/icons"
import LocalButton, { LocalButtonProps } from "./_localButton"
import { useAvatarMicManager } from "src/conditionals/Avatar"

type AvatarMicButtonProps = {
  id: LocalButtonProps["id"]
  isWithoutTitle: LocalButtonProps["isWithoutTitle"]
  isFirst: LocalButtonProps["isFirst"],
  isLast: LocalButtonProps["isLast"]
}

export const AvatarMicButton = ({ 
  id,
  isWithoutTitle,
  isFirst,
  isLast
}: AvatarMicButtonProps) => {
  const { t } = useTranslation()
  const { isEnabled, toggleMic } = useAvatarMicManager()

  const dataMicrophoneIcon = useMemo(() => {
    return {
      icons: [<Icon src={FaMicrophoneSlash} />, <Icon src={FaMicrophone} />],
      names: [t("Unmute"), t("Mute")]
    }
  }, [t])

  return (
    <LocalButton
      id={id}
      names={dataMicrophoneIcon.names}
      icons={dataMicrophoneIcon.icons}
      enabled={isEnabled}
      setter={toggleMic}
      isFirst={isFirst}
      isLast={isLast}
      isWithoutTitle={isWithoutTitle}
      isDisabled={false}
      showSelecedStyling={false}
      showWarningIcon={false}
    />
  )
}
